// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emp-dash-cards {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top:50px;
}

.emp-card {
  width: 240px;
  display: flex;
  align-items: center;
  background: white;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
  border: none; /* Removes any border */
}

/* First Card Background - Default */
.emp-punch-in {
  background: #4caf50; /* Green background */
  color: white;
}

/* First Card Background - After Clicking */
.emp-punched-out {
  background: #DE7921; /* Red background after Punch Out */
  color: white;
}

/* Ensure the first card icon is white when active */
.emp-punch-in .emp-icon,
.emp-punched-out .emp-icon {
  color: white;
}

/* Next three cards (Login Time, Location, Device) */
.emp-card:not(.emp-punch-in):not(.emp-punched-out) .emp-icon {
  color: black; /* Set icon color to black */
}

.emp-card:not(.emp-punch-in):not(.emp-punched-out) .emp-text {
  color: #004DC6; /* Set text color to blue */
}



.emp-card-content {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 20px; /* Increased gap between icon and text */
}

.emp-icon {
  font-size: 1.6rem;
  
  background: rgba(200, 200, 200, 0.2); /* Light grey background */
  padding: 10px; /* Space around the icon */
  border-radius: 8px; /* Rounded corners */
  display: inline-flex; /* Keep it centered */
  align-items: center; /* Vertical alignment */
  justify-content: center; /* Horizontal alignment */
 
}

.emp-text {
  font-size: 1rem;
  font-weight: bold;
}

.emp-label {
  font-size: 0.8rem;
  color: #555;
  display: block;
}

/* Add this to your EmpDashCards.css */

/* Blink animation */
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.emp-blink {
  animation: blink 1s ease-in-out infinite;
}




.camera-popup {
  position: fixed;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
  padding: 25px 22px;
  z-index: 1000;
  width: 550px;
  max-width: 95%;
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  animation: fadeIn 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

/* Title */
.camera-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #222;
  margin: 0;
}

/* Video */
.camera-video {
  width: 100%;
  height: auto;
  max-height: 320px;
  border-radius: 16px;
  object-fit: cover;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

/* Status */
.camera-status {
  font-size: 1.05rem;
  color: #444;
  margin-top: 12px;
  letter-spacing: 0.5px;
}

.location-link
{
  color: #004DC6;
  font-size: 10px;
}



/* Smooth Fade In Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate(-50%, -55%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}



@media (max-width: 768px) {
  .emp-dash-cards {
    flex-direction: column; /* Stack cards vertically */
    align-items: center; /* Center align cards */
    gap: 20px; /* Increase gap for better spacing */
    width: 100%;
  }

  .emp-card {
    width: 100%; /* Make cards take most of the screen width */
    max-width: 380px; /* Prevent excessive width */
    padding: 20px; /* Slightly increase padding for better touch experience */
    width: 300px;
  }
  emp-card emp-punch-in
  {
    width: 120%;
  }
  .emp-card-content {
    flex-direction: row; /* Keep content inline */
    gap: 15px; /* Reduce gap slightly */
  }
 
  .emp-punch-button {
    font-weight: bold;
    cursor: pointer;
    width: 120%;
    transition: transform 0.2s ease-in-out;
  }
  
  .emp-punch-button:active {
    transform: scale(0.95);
  }
  .emp-icon {
    font-size: 1.6rem; /* Slightly reduce icon size */
  }

  .emp-text {
    font-size: 0.9rem; /* Slightly reduce text size */
    text-align: center;
    
  }

  .emp-label {
    font-size: 0.75rem; /* Adjust label size */
  }

 

  @media (max-width: 768px) {
    .emp-punch-in,
    .emp-punched-out {
      width: 340px; /* Make the first card bigger */
      height: 80px; /* Increase height */
      font-size: 1.2rem; /* Increase text size */
    }
  
    .emp-punch-in .emp-icon,
    .emp-punched-out .emp-icon {
      font-size: 2rem; /* Make the icon slightly bigger */
    }
  }
 
    .camera-popup {
      top: 50%;
      width: 90%;
      padding: 20px 18px;
      border-radius: 18px;
      gap: 20px;
    }
  
    .camera-title {
      font-size: 1.6rem;
    }
  
    .camera-video {
      max-height: 260px;
      border-radius: 14px;
    }
  
    .camera-status {
      font-size: 1rem;
    
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/EmpDashCards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,+DAA+D;EAC/D,YAAY,EAAE,uBAAuB;AACvC;;AAEA,oCAAoC;AACpC;EACE,mBAAmB,EAAE,qBAAqB;EAC1C,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB,EAAE,mCAAmC;EACxD,YAAY;AACd;;AAEA,oDAAoD;AACpD;;EAEE,YAAY;AACd;;AAEA,oDAAoD;AACpD;EACE,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,cAAc,EAAE,2BAA2B;AAC7C;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS,EAAE,wCAAwC;AACrD;;AAEA;EACE,iBAAiB;;EAEjB,oCAAoC,EAAE,0BAA0B;EAChE,aAAa,EAAE,0BAA0B;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,oBAAoB,EAAE,qBAAqB;EAC3C,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;;AAEpD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA,sCAAsC;;AAEtC,oBAAoB;AACpB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,wCAAwC;AAC1C;;;;;AAKA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4DAA4D;EAC5D,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;;;AAIA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;;;AAIA;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB,EAAE,uBAAuB;IAC5C,SAAS,EAAE,oCAAoC;IAC/C,WAAW;EACb;;EAEA;IACE,WAAW,EAAE,6CAA6C;IAC1D,gBAAgB,EAAE,4BAA4B;IAC9C,aAAa,EAAE,0DAA0D;IACzE,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,mBAAmB,EAAE,wBAAwB;IAC7C,SAAS,EAAE,wBAAwB;EACrC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,sCAAsC;EACxC;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,iBAAiB,EAAE,8BAA8B;EACnD;;EAEA;IACE,iBAAiB,EAAE,8BAA8B;IACjD,kBAAkB;;EAEpB;;EAEA;IACE,kBAAkB,EAAE,sBAAsB;EAC5C;;;;EAIA;IACE;;MAEE,YAAY,EAAE,+BAA+B;MAC7C,YAAY,EAAE,oBAAoB;MAClC,iBAAiB,EAAE,uBAAuB;IAC5C;;IAEA;;MAEE,eAAe,EAAE,kCAAkC;IACrD;EACF;;IAEE;MACE,QAAQ;MACR,UAAU;MACV,kBAAkB;MAClB,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,eAAe;;EAEnB;;AAEF","sourcesContent":[".emp-dash-cards {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top:50px;\n}\n\n.emp-card {\n  width: 240px;\n  display: flex;\n  align-items: center;\n  background: white;\n  padding: 12px;\n  border-radius: 8px;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);\n  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;\n  border: none; /* Removes any border */\n}\n\n/* First Card Background - Default */\n.emp-punch-in {\n  background: #4caf50; /* Green background */\n  color: white;\n}\n\n/* First Card Background - After Clicking */\n.emp-punched-out {\n  background: #DE7921; /* Red background after Punch Out */\n  color: white;\n}\n\n/* Ensure the first card icon is white when active */\n.emp-punch-in .emp-icon,\n.emp-punched-out .emp-icon {\n  color: white;\n}\n\n/* Next three cards (Login Time, Location, Device) */\n.emp-card:not(.emp-punch-in):not(.emp-punched-out) .emp-icon {\n  color: black; /* Set icon color to black */\n}\n\n.emp-card:not(.emp-punch-in):not(.emp-punched-out) .emp-text {\n  color: #004DC6; /* Set text color to blue */\n}\n\n\n\n.emp-card-content {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 20px; /* Increased gap between icon and text */\n}\n\n.emp-icon {\n  font-size: 1.6rem;\n  \n  background: rgba(200, 200, 200, 0.2); /* Light grey background */\n  padding: 10px; /* Space around the icon */\n  border-radius: 8px; /* Rounded corners */\n  display: inline-flex; /* Keep it centered */\n  align-items: center; /* Vertical alignment */\n  justify-content: center; /* Horizontal alignment */\n \n}\n\n.emp-text {\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.emp-label {\n  font-size: 0.8rem;\n  color: #555;\n  display: block;\n}\n\n/* Add this to your EmpDashCards.css */\n\n/* Blink animation */\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.emp-blink {\n  animation: blink 1s ease-in-out infinite;\n}\n\n\n\n\n.camera-popup {\n  position: fixed;\n  top: 55%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);\n  padding: 25px 22px;\n  z-index: 1000;\n  width: 550px;\n  max-width: 95%;\n  text-align: center;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  animation: fadeIn 0.3s ease-in-out;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n}\n\n/* Title */\n.camera-title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #222;\n  margin: 0;\n}\n\n/* Video */\n.camera-video {\n  width: 100%;\n  height: auto;\n  max-height: 320px;\n  border-radius: 16px;\n  object-fit: cover;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Status */\n.camera-status {\n  font-size: 1.05rem;\n  color: #444;\n  margin-top: 12px;\n  letter-spacing: 0.5px;\n}\n\n.location-link\n{\n  color: #004DC6;\n  font-size: 10px;\n}\n\n\n\n/* Smooth Fade In Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -55%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n\n\n@media (max-width: 768px) {\n  .emp-dash-cards {\n    flex-direction: column; /* Stack cards vertically */\n    align-items: center; /* Center align cards */\n    gap: 20px; /* Increase gap for better spacing */\n    width: 100%;\n  }\n\n  .emp-card {\n    width: 100%; /* Make cards take most of the screen width */\n    max-width: 380px; /* Prevent excessive width */\n    padding: 20px; /* Slightly increase padding for better touch experience */\n    width: 300px;\n  }\n  emp-card emp-punch-in\n  {\n    width: 120%;\n  }\n  .emp-card-content {\n    flex-direction: row; /* Keep content inline */\n    gap: 15px; /* Reduce gap slightly */\n  }\n \n  .emp-punch-button {\n    font-weight: bold;\n    cursor: pointer;\n    width: 120%;\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .emp-punch-button:active {\n    transform: scale(0.95);\n  }\n  .emp-icon {\n    font-size: 1.6rem; /* Slightly reduce icon size */\n  }\n\n  .emp-text {\n    font-size: 0.9rem; /* Slightly reduce text size */\n    text-align: center;\n    \n  }\n\n  .emp-label {\n    font-size: 0.75rem; /* Adjust label size */\n  }\n\n \n\n  @media (max-width: 768px) {\n    .emp-punch-in,\n    .emp-punched-out {\n      width: 340px; /* Make the first card bigger */\n      height: 80px; /* Increase height */\n      font-size: 1.2rem; /* Increase text size */\n    }\n  \n    .emp-punch-in .emp-icon,\n    .emp-punched-out .emp-icon {\n      font-size: 2rem; /* Make the icon slightly bigger */\n    }\n  }\n \n    .camera-popup {\n      top: 50%;\n      width: 90%;\n      padding: 20px 18px;\n      border-radius: 18px;\n      gap: 20px;\n    }\n  \n    .camera-title {\n      font-size: 1.6rem;\n    }\n  \n    .camera-video {\n      max-height: 260px;\n      border-radius: 14px;\n    }\n  \n    .camera-status {\n      font-size: 1rem;\n    \n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
